import { useLanguage } from "@/contexts/LanguageContext";
import { useSiteContent, pickLocalized } from "@/contexts/SiteContentContext";
import { Quote, Star } from "lucide-react";

const Testimonials = () => {
  const { t, locale } = useLanguage();
  const { content } = useSiteContent();
  const list = content?.testimonials || [];

  if (list.length === 0) return null;

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="container-px mx-auto max-w-7xl py-24 lg:py-32"
    >
      <div className="max-w-2xl">
        <p className="text-xs uppercase tracking-[0.22em] text-sky-700 font-medium">
          {t("testimonials.eyebrow")}
        </p>
        <h2 className="font-display mt-3 text-4xl lg:text-6xl font-light tracking-tighter text-neutral-950 text-balance">
          {t("testimonials.title")}
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-5">
        {list.map((tt, i) => (
          <div
            key={i}
            data-testid={`testimonial-${i}`}
            className="rounded-3xl border border-neutral-200 bg-white p-8 lg:p-10 hover:shadow-[0_18px_40px_rgba(0,0,0,0.06)] transition-shadow"
          >
            <Quote className="w-7 h-7 text-sky-600/70" />
            <p className="mt-5 text-lg leading-relaxed text-neutral-800 text-balance">
              {pickLocalized(tt.text, locale)}
            </p>
            <div className="mt-7 flex items-center justify-between">
              <div>
                <div className="font-display text-base font-medium text-neutral-950">
                  {tt.name}
                </div>
                <div className="text-xs text-neutral-500 mt-0.5">
                  {pickLocalized(tt.role, locale)}
                </div>
              </div>
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
